module.exports = __webpack_public_path__ + "static/media/eye.bac83d47.svg";